import { ButtonRounded } from 'is24-corecss';
import { useTranslation } from 'react-i18next';
import { Modal as Modals } from '@/components/common/display/modal/v3';
import type { BenefitModalProps } from '@/@types/benefitModalProps';
import { createTelLinkHandler } from '@/utils/telLinkUtils';
import { AdacBanner } from '../shared/AdacBanner';
import { styles } from './AdacPolicyOverviewModal.styles';
import type { PolicyDetailsProps } from './PolicyDetails';
import { PolicyDetails } from './PolicyDetails';
import { mockAdacPolicyDetails } from './mock';
import { adacContactInformation } from '../contactInformation';

const { V3: Modal } = Modals;

export type AdacPolicyOverviewModalProps = BenefitModalProps & Omit<PolicyDetailsProps, 'policy'>;

export const AdacPolicyOverviewModal = ({ isVisible, onClose, ...policyActions }: AdacPolicyOverviewModalProps) => {
  const { t } = useTranslation('adac', { keyPrefix: 'policyOverview' });

  return (
    <Modal isVisible={isVisible} onClose={onClose} width={1000} viewportHeight={false}>
      <Modal.Header>
        <Modal.Title>{t('title')}</Modal.Title>
        <Modal.CloseButton aria-label={t('close')} />
      </Modal.Header>
      <Modal.Content className={styles.body}>
        <AdacBanner imageAlt={t('imageAlt')} className={styles.hero} />
        <Modal.Tabs>
          <Modal.Tab
            tabKey='overview'
            title={t('overview')}
            className={`padding-horizontal-l palm-padding-horizontal-m padding-bottom-l ${styles.content} horizontal-center`}
          >
            <p className={`${styles.description} font-body-large-regular margin-bottom-m`}>{t('description')}</p>
            <PolicyDetails policy={mockAdacPolicyDetails} {...policyActions} />
          </Modal.Tab>
        </Modal.Tabs>
      </Modal.Content>
      <Modal.Footer className={`${styles.footer} padding-top-xl padding-bottom-xxl`}>
        <CallAdacButton />
      </Modal.Footer>
    </Modal>
  );
};

const CallAdacButton = () => {
  const { t } = useTranslation('adac', { keyPrefix: 'policyOverview' });
  const { phoneNumber, dialNumber } = adacContactInformation;
  const callAdac = createTelLinkHandler(dialNumber);

  return (
    <ButtonRounded as='a' href={`tel:${dialNumber}`} variant='filledDefault' size='large' onClick={callAdac}>
      {t('call', { phoneNumber })}
    </ButtonRounded>
  );
};
